import * as types from '../mutation-types'

// state
export const state = {
  nachrichten: [],
  neueposts: '',
  timer: ''

}

// mutations
export const mutations = {

  [types.FETCH_NACHRICHTEN_SUCCESS] (state, { nachrichten }) {
    state.nachrichten = nachrichten.thread
    state.neueposts = nachrichten.count
  },
  [types.FETCH_NACHRICHTEN_FAILURE] (state) {
    console.log('Fehler beim Suchen')
  }
}

// actions
export const actions = {

  intervalCheck ({ commit }) {
    console.log('interval gogo')
  },

  async fetchNachrichten ({ commit }, payload) {
    console.log('nachrichten fetch...')

    const { data } = await axios.get('/api/v1/nachrichten')

    if (data) {
      commit(types.FETCH_NACHRICHTEN_SUCCESS, { nachrichten: data })
    } else {
      commit(types.FETCH_NACHRICHTEN_FAILURE)

      this.dispatch('responseMessage', {
        type: 'warning',
        text: 'Keine Verbindung zum Chat'
      })
    }
  }
}

// getters
export const getters = {

  fetchNachrichten: state => {
    return state.nachrichten
  },
  fetchNeueNachrichten: state => {
    return state.neueposts
  },

  // betriebecalc: (state) => (betriebe) => {
  //   let resultArray = []

  // },
  nachrichtenszahl: state => state.nachrichten.length
}
